// Func = limiting Scope for this file
var lastScrollTop = 0;
var sk;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		/* Initialize Parallax Lybrary */
		const istouch = document.querySelector('.mod-no-touchevents')
		if( $(window).width() > 767 ){
			if(istouch){
				sk = skrollr.init();
			}
		}

		// scrollDownAction(20, 'scroll');

		const catiSelect = document.querySelector('#attraction-category');
		if(catiSelect){
			catiSelect.querySelectorAll('option').forEach( (el)=>{
				if( el.textContent == "Quirky & Unique Attractions" ){
					el.textContent = "Trails";
				}
			});
		}

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	const roomsnav = document.querySelector('.accommodations__nav');
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		if(roomsnav){
			roomsnav.classList.add('hiddened');
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(roomsnav){
			roomsnav.classList.remove('hiddened');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

var hambbtn = document.querySelectorAll('.header__hamburger, .header__nav-close, .hamburger__btn');
if(hambbtn.length > 0){
	hambbtn.forEach((ele)=>{
		ele.addEventListener('click', function (e) {
			e.preventDefault();
			var menuObj = document.querySelector('.header');
			menuObj.classList.remove('open-book');
			menuObj.classList.toggle('open-nav');
		});
	})
}

var bookbtn = document.querySelectorAll('.header__booking-btn, .header__booking-close');
if(bookbtn.length > 0){
	bookbtn.forEach((ele)=>{
		ele.addEventListener('click', function (e) {
			e.preventDefault();
			var menuObj = document.querySelector('.header');
			menuObj.classList.toggle('open-book');
			menuObj.classList.remove('open-nav');
		});
	})
}


// TABS ROOMS
//var firstTab = document.querySelector('.list-alt__tabs__item:first-child a');
var firstTab = document.querySelector('#tab-Studios a');
if (!firstTab) {
	firstTab = document.querySelector('.list-alt__tabs__item:first-child a');
}

if (firstTab) {
	firstTab.classList.add('active');
	var filterFirts = firstTab.getAttribute("data-target");
	var sectionFirst = firstTab.closest('section');

	sectionFirst.querySelectorAll('.list-alt__item').forEach((allDivsFirst) => {
		allDivsFirst.classList.remove('list-alt__item__hide');
	})

	var hideSelectorsFirst = '.list-alt__item:not(' + filterFirts + ')';
	sectionFirst.querySelectorAll(hideSelectorsFirst).forEach((hideDivsFirst) => {
		hideDivsFirst.classList.add('list-alt__item__hide');
		document.querySelector('.list-alt__ofrooms').appendChild(hideDivsFirst);
	});

	var tabbuttons = document.querySelectorAll('.list-alt__tabs__btn');
	var tc = 0;

	for (tc; tc < tabbuttons.length; tc++) {
		tabbuttons[tc].addEventListener('click', function () {

			if (!this.classList.contains('active')) {
				
				tabbuttons.forEach((tabbuttons) => { tabbuttons.classList.remove('active') })
				
				this.classList.add('active');
				var filterdis = this.getAttribute("data-target");
				var section = this.closest('section');

				section.querySelectorAll('.list-alt__item').forEach((allDivs) => {
					allDivs.classList.add('list-alt__item__hide');
				});
				section.querySelectorAll('.desert-divider').forEach((divs)=>{
					divs.classList.add('d-none');
				});
				
				setTimeout(()=>{

					if (filterdis != '') {
						var showSelectors = '.list-alt__item' + filterdis ;
						var hideSelectors = '.list-alt__item:not(' + filterdis  + ')';
						section.querySelectorAll(showSelectors).forEach((showDivs) => {
							showDivs.classList.remove('list-alt__item__hide');
						});
						section.querySelectorAll(hideSelectors).forEach((hideDivs) => {
							document.querySelector('.list-alt__ofrooms').appendChild(hideDivs);
						});
					}
					//Toggle animations first quad
					var firtsQuad = document.querySelector('.list-alt__item' + filterdis);
					firtsQuad.querySelectorAll('.animate-fade').forEach((animated) => {
						animated.classList.add('fade-in', 'visible');
					});
					firtsQuad.querySelectorAll('.lazyload').forEach( (lazyitem)=>{
						var srcs = lazyitem.dataset.srcset;
						lazyitem.setAttribute('src',srcs);
						lazyitem.classList.add('visible');
					});
					section.querySelectorAll('.desert-divider').forEach((divs)=>{
						divs.classList.remove('d-none');
					});
					sk.refresh();
				},100);

			}
		});
	}
}

//Top tabs
if (!firstTab) {
	firstTab = document.querySelector('.accommodations__nav__item:first-child a');
}
if (firstTab) {
	var tabbuttonsb = document.querySelectorAll('.accommodations__nav__btn');
	
	for (var tc = 0; tc < tabbuttonsb.length; tc++) {
		console.log('wtf');
		tabbuttonsb[tc].addEventListener('click', function () {
			var ind = this.parentNode;
			var ti = Array.from(ind.parentNode.children).indexOf(ind)
			
			if (!this.classList.contains('active')) {
				
				tabbuttonsb.forEach((tabbuttonsb) => { tabbuttonsb.classList.remove('active') })

				document.querySelectorAll('.list-alt__tabs__btn').forEach( ele=>{ ele.classList.remove('active')});
				console.log(document.querySelectorAll('.list-alt__tabs__item')[1] );
				document.querySelectorAll('.list-alt__tabs__item')[ti].querySelector('a').classList.add('active');
				
				var filterdis = this.getAttribute("data-target");
				var section = document.querySelector('#rooms-sc');

				section.querySelectorAll('.list-alt__item').forEach((allDivs) => {
					allDivs.classList.add('list-alt__item__hide');
				});
				section.querySelectorAll('.desert-divider').forEach((divs)=>{
					divs.classList.add('d-none');
				});
				
				var body = $("html, body");
				body.stop().animate({
					scrollTop: $('#rooms-sc').offset().top
				}, 500, 'swing');
				setTimeout(()=>{

					if (filterdis != '') {
						var showSelectors = '.list-alt__item' + filterdis ;
						var hideSelectors = '.list-alt__item:not(' + filterdis  + ')';
						section.querySelectorAll(showSelectors).forEach((showDivs) => {
							showDivs.classList.remove('list-alt__item__hide');
						});
						section.querySelectorAll(hideSelectors).forEach((hideDivs) => {
							document.querySelector('.list-alt__ofrooms').appendChild(hideDivs);
						});
					}
					//Toggle animations first quad
					var firtsQuad = document.querySelector('.list-alt__item' + filterdis);
					firtsQuad.querySelectorAll('.animate-fade').forEach((animated) => {
						animated.classList.add('fade-in', 'visible');
					});
					firtsQuad.querySelectorAll('.lazyload').forEach( (lazyitem)=>{
						var srcs = lazyitem.dataset.srcset;
						lazyitem.setAttribute('src',srcs);
						lazyitem.classList.add('visible');
					});
					section.querySelectorAll('.desert-divider').forEach((divs)=>{
						divs.classList.remove('d-none');
					});
					sk.refresh();
				},100);

			}
		});
	}
}

/* Menu Image Over */
var menuItems = document.querySelectorAll('.privary-navigation__item');
var menuItemPics = document.querySelectorAll('.header__nav-pic');
if(menuItems && window.innerWidth > 767){
	menuItems.forEach((ele,index)=>{
		ele.addEventListener('mouseover',(e)=>{
			menuItemPics[index].classList.add('active');
		});
		ele.addEventListener('mouseout',(e)=>{
			menuItemPics[index].classList.remove('active');
		});
	});
}